import { Button, Input, Select } from "components/forms";
import { Field, FormikProvider, useFormik } from "formik";
import logo from 'assets/pictures/header-logo.png';
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { save } from "store/shop/actions";
import { useQuery } from "utilities";
import API_ENDPOINTS from "utilities/apiEndpoints";
import notification from "utilities/notification";

const LoginForm = () => {
	const { data, isLoading } = useQuery(API_ENDPOINTS.SHOPS);
	const dispatch = useDispatch();

	const companies = [
		{ label: 'Select your company', value: null },
		...data.map(item => ({ label: item?.shopname, value: item?.id }))
	];

	const formik = useFormik({
		initialValues: {
			shop_id: '',
			password: ''
		},
		onSubmit: (values) => {
			dispatch(save(API_ENDPOINTS.SHOP_LOGIN, values)).then(response => {
				if (response?.success) {
					notification('success', response?.message);
					window.location.href = "/products";
				}
			});
		}
	});

	return (
		<Fragment>
			<FormikProvider value={formik}>
				<form onSubmit={formik.handleSubmit} className="login-forms text-center">

					{/* Logo */}
					<img src={logo} alt="Logo" style={{ height: '3rem' }} />

					{/* Title */}
					<h6 className='mb-2 fw-bold'>LOG IN</h6>

					{/* Company Select */}
					<div className="mb-3 text-start">
						<Field
							name='shop_id'
							options={companies}
							component={Select}
							disabled={isLoading}
							className='form-control'
						/>
					</div>

					{/* Password Input */}
					<div className="mb-4 text-start">
						<Field
							type='password'
							name='password'
							component={Input}
							className='form-control'
							placeholder="Password"
						/>
					</div>

					{/* Submit Button */}
					<Button
						type="submit"
						label="Log in"
						className="btn-submit w-100"
					/>

				</form>
			</FormikProvider>
		</Fragment>
	);
};

export default LoginForm;
